import { LOG_T_SHELF_BY_CAMERA_END } from "@/components/log/taggingIds"
import React from "react"

interface AddToLibraryButtonProps {
  selectedCount: number
  onAddToLibrary: () => void
  disabled?: boolean
}

/**
 * 도서 등록 버튼 컴포넌트
 * 선택된 도서 수를 표시하고 등록 액션을 처리
 */
const AddToLibraryButton = React.memo<AddToLibraryButtonProps>(
  ({ selectedCount, onAddToLibrary, disabled = false }) => {
    const isDisabled = disabled || selectedCount === 0

    return (
      <div className="absolute bottom-5 left-1/2 mx-auto h-[56px] w-full -translate-x-1/2 px-5 md:max-w-[768px]">
        <button
          id={LOG_T_SHELF_BY_CAMERA_END}
          onClick={onAddToLibrary}
          className="disabled:text-rl-gray-font-disabled w-full rounded-xl bg-[#007AFF] py-4 shadow-sm transition-colors duration-200 hover:bg-[#0056CC] disabled:bg-rl-gray-300 disabled:hover:bg-rl-gray-300"
          disabled={isDisabled}
        >
          <span className="typo-rl-headline1 text-white">
            도서({selectedCount}권) 내 서재에 등록
          </span>
        </button>
      </div>
    )
  },
)

AddToLibraryButton.displayName = "AddToLibraryButton"

export default AddToLibraryButton
